






















































































































import StudentBaseInformation from "./StudentBaseInformation.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "studentCourseApplyBase",
  components: {
    StudentBaseInformation,
  },
})
export default class extends Vue {
  @Prop() public studentDto!: any;
  @Prop() public studentInfoDto!: any;

  get applyStatus() {
    if (this.studentInfoDto) {
      return this.studentInfoDto.gearStudentApplyCountInfoDto;
    }
    return {};
  }
}
